module.exports = __webpack_public_path__ + "img/answer5.0d6377a5.jpg";